// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import { i18n } from '../index'
import cx from 'classnames'
import { Paper, Table, TableFooter, TableBody, TableHead, TableRow, TableCell } from '@mui/material'
import type { DailySales as DailySalesType, DailySalesFieldName, ManagementTarget } from './dailyManagementTypes'
import css from './table.css'

const calculateTotal = (fieldName: DailySalesFieldName, targets: Array<ManagementTarget>): number =>
  Math.round(targets.reduce((sum, target) => (sum += target[fieldName]), 0) * 100) / 100

type DailySalesRowProps = {
  data: ManagementTarget
  onChange: (...args: Array<any>) => any
}

const DailySalesRow = ({ data, onChange }: DailySalesRowProps) => (
  <TableRow className={css.tableRow}>
    <TableCell className={css.tableCell}>{i18n.t(`dailyManagement.label.area${data.type}`)}</TableCell>
    <TableCell className={cx(css.tableCell, css.tableCellCentered)}>{data.target}</TableCell>
    <TableCell className={cx(css.tableCell, css.tableCellCentered)}>{data.actual}</TableCell>
  </TableRow>
)

type DailySalesProps = {
  data: Array<DailySalesType>
}

const DailySales = ({ data }: DailySalesProps) => (
  <Paper>
    <div className={css.component}>
      <Table className={css.table}>
        <TableHead>
          <TableRow className={css.tableHeadinRow}>
            <TableCell className={css.tableHeadingCell}>{i18n.t('dailyManagement.label.areaName')}</TableCell>
            <TableCell className={cx(css.tableHeadingCell, css.tableCellCentered)}>
              {i18n.t('dailyManagement.label.budget')}
            </TableCell>
            <TableCell className={cx(css.tableHeadingCell, css.tableCellCentered)}>
              {i18n.t('dailyManagement.label.actual', {
                unit: '€',
              })}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((sale) => (
            <DailySalesRow data={sale} key={sale.type} />
          ))}
        </TableBody>
        <TableFooter>
          <TableRow className={css.tableFootRow}>
            <TableCell className={css.tableFootCell}>{i18n.t('dailyManagement.label.total')}</TableCell>
            <TableCell className={cx(css.tableFootCell, css.tableCellCentered)}>
              {calculateTotal('target', data)}
            </TableCell>
            <TableCell className={cx(css.tableFootCell, css.tableCellCentered)}>
              {calculateTotal('actual', data)}
            </TableCell>
          </TableRow>
        </TableFooter>
      </Table>
    </div>
  </Paper>
)

export default DailySales
